import {createSlice} from '@reduxjs/toolkit'

const initialTemplateState = {
  template: null,
  formDetail: null,
  templateDropdown: [],
  isGlobalTemplatePage: false,
  isUseTemplateDialog: false,
  selectedTemplateDetail: null,
  selectedTemplateDetailLoading: false,
  isOpenTemplateDialog: false
}

export const TemplateSlices = createSlice({
  name: 'templates',
  initialState: initialTemplateState,
  reducers: {
    template: (state, action) => {
      state.template = action.payload.template
    },
    form_detail: (state, action) => {
      state.formDetail = action.payload.formDetail
    },
    templatesList: (state, action) => {
      state.templateDropdown = action.payload.templates
    },
    isGlobalTemplatePage: (state, action) => {
      state.isGlobalTemplatePage = action.payload
    },
    setIsUseTemplateDialog: (state, action) => {
      state.isUseTemplateDialog = action.payload;
    },
    setSelectedTemplateDetail: (state, action) => {
      state.selectedTemplateDetail = action.payload;
    },
    setSelectedTemplateDetailLoading: (state, action) => {
      state.selectedTemplateDetailLoading = action.payload;
    },
    setIsOpenTemplateDialog: (state, action) => {
      state.isOpenTemplateDialog = action.payload;
    },
  },
})
